'use strict';

var Classnames = require('classnames');
var React = require('react');
var Reflux = require('reflux');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./select.scss');
}

var Store = require('../store');

var Select = React.createClass({
    propTypes: {
        // list of values for <option>
        options: React.PropTypes.array.isRequired,

        // reflux store key
        keyname: React.PropTypes.string.isRequired,

        // html label
        label: React.PropTypes.string,

        // autocomplete attribute
        autocomplete: React.PropTypes.string,

        // red border if edited and still empty
        required: React.PropTypes.bool,

        // show red border anyway
        alert: React.PropTypes.bool,
    },
    mixins: [
        Reflux.listenTo(Store.Store, 'onStoreChange', 'onStoreChange')
    ],
    onStoreChange: function(store) {
        var v;
        if (typeof this.props.source === 'undefined') {
            v = store.fields[this.props.keyname];
        } else {
            v = this.props.source();
        }
        this.setState({
            value: v,
            stored: v,
        });
    },
    getInitialState: function() {
        return {
            value: '',
            tagId: 'mux_' + this.props.keyname,
            hasEdited: false
        };
    },

    handleChange: function(event) {
        Store.Actions.setProjectField(this.props.keyname, event.target.value);
        this.setState({
            hasEdited: true,
        });
    },
    render: function() {
        var label;
        if (this.props.label) {
            label = (
                <label htmlFor={this.state.tagId}>
                    {this.props.label}
                </label>
            );
        }
        var classes = Classnames({
            'forms-control': true,
            'forms-control-requiredLabel': !this.state.value && (this.props.alert || (this.props.required && this.state.hasEdited)),
        });
        return (
            <div className='select'>
                {label}
                <div className={classes}>
                    <select ref          = 'select'
                            id           = {this.state.tagId}
                            name         = {this.props.keyname}
                            value        = {this.state.value}
                            /* autoComplete = {this.props.autocomplete} */
                            onChange     = {this.handleChange}>
                        <option value=""></option>
                        {this.props.options.map(r => {
                            if (typeof r == 'string') {
                                return <option key={r} value={r}>{r}</option>;
                            } else {
                                return <option key={r.key} value={r.key}>{r.value}</option>;
                            }
                        })}
                    </select>
                </div>
            </div>
        );
    }
});

module.exports = Select;



// WEBPACK FOOTER //
// ./src/forms/select.jsx